<template>
  <div class="heatmap-legend-element">
      <div>{{ track }}</div>
      <v-btn-toggle multiple v-model="shownFeatures">
        <div 
            class="heatmap-legend-element-buttons" 
            :style="`width: ${width}%`"
        >
        <!-- :class="getTextColor(el)" -->
            <v-btn
                v-for="el in trackData"
                :key="el.value"
                :value="el.value"
                small
                :class="getTextColor(el)"
                elevation="0"
                min-height="32"
                :plain="!el.value"
                :color="getBackgroundColor(el)"
            >
                <span style="white-space: pre;">
                    {{ getButtonLabel(el) }}
                </span>
            </v-btn>
        </div> 
      </v-btn-toggle>
  </div>
</template>

<script>
export default {
    name: "heatmap-legend-element",

    props: ['track', 'trackData', 'width'],

    data: () => ({
        shownFeatures: [],
        isLoaded: false,
    }),

    methods: {
        getButtonLabel(el) {
            if (el.label.length === 0) { return 'Missing' }
            if (el.label.length > 12 && el.label.split(' ').length > 1) { 
                let labelArr = el.label.split(' ')
                let labelStart, labelEnd
                if (el.label.split(' ').length > 2) {
                    labelStart = labelArr.slice(0, 2).join(' ')
                    labelEnd = labelArr.slice(2,).join(' ')
                } else {
                    labelStart = labelArr.slice(0, 1).join(' ')
                    labelEnd = labelArr.slice(1,).join(' ')
                }
                
                return `\n${labelStart}\n${labelEnd}\n`
            }
            
            return el.label

        },
        getBackgroundColor(el) {
            // if (this.shownFeatures.includes(el.value)) {
            //     console.log('heatmap legend value matched', el.value, this.shownFeatures)
            // } else {
            //     console.log('heatmap legend value mismatched', el.value, this.shownFeatures)
            // }
            console.log('heatmap legend el', el)
            return this.shownFeatures.includes(el.value) ? el.color : '#ffffff'
        },

        hexToLuminance(hex) {
  // Remove the '#' symbol if present
            hex = hex.replace(/^#/, '');

        // Convert hex to RGB values
            const r = parseInt(hex.substring(0, 2), 16);
            const g = parseInt(hex.substring(2, 4), 16);
            const b = parseInt(hex.substring(4, 6), 16);

            // Calculate luminance
            const R = r / 255;
            const G = g / 255;
            const B = b / 255;

            const rLinear = R <= 0.03928 ? R / 12.92 : Math.pow((R + 0.055) / 1.055, 2.4);
            const gLinear = G <= 0.03928 ? G / 12.92 : Math.pow((G + 0.055) / 1.055, 2.4);
            const bLinear = B <= 0.03928 ? B / 12.92 : Math.pow((B + 0.055) / 1.055, 2.4);

            const luminance = 0.2126 * rLinear + 0.7152 * gLinear + 0.0722 * bLinear;

            return luminance;
        },
        getTextColor(el) {
            const backgroundColor = this.getBackgroundColor(el)
            if (this.hexToLuminance(backgroundColor) > 0.5) {
                return `black--text`
            } else {
                return `white--text`
            }
        },
        
    },

    watch: {
        shownFeatures() {
            if (this.isLoaded) {
                this.$store.dispatch('updateShownFeatures', 
                { track: this.track, shownFeatures: this.shownFeatures }) 
            }
            this.isLoaded = true
        },
        trackData() {
            this.shownFeatures = this.trackData.map(el => el.value) 
        },
        track() {
            this.shownFeatures = this.trackData.map(el => el.value) 
        }
    },

    mounted() { 
        this.shownFeatures = this.trackData.map(el => el.value) 
    }

}
</script>

<style>
.heatmap-legend-element {
    width: 100%;
    margin-top: 10px;
    min-width: 120px;
    display: flex; 
    flex-direction: column;
}

.heatmap-legend-element-buttons {
    display: flex; 
    flex-direction: column;
}

.heatmap-legend-element .v-btn {
    border: solid 1px #000000;
}

</style>